import styled from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import SocialBadge from './SocialBadge';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { getDimensions } from '../../lib/getDimensions';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContentHolder = styled.div.withConfig({
  displayName: "AvatarContentHolder__ContentHolder",
  componentId: "sc-11e0bp0-0"
})(["border-radius:", ";font-size:initial;", ";"], ({
  type
}) => type === 'productId' ? '3px' : '50%', ({
  $cssStyles
}) => $cssStyles);
const AvatarContentHolder = ({
  href,
  children,
  size = 'sm',
  type,
  socialNetwork,
  borderWidth,
  borderColor,
  borderStyle = 'none'
}) => {
  const contentHolderProps = {
    'data-size': size,
    'data-test-id': 'content-holder',
    'data-type': type,
    'data-border-size': borderWidth,
    type
  };
  const cssMap = useMapTokenPropsToCSS({
    alignItems: 'center',
    borderColor,
    borderStyle,
    borderWidth,
    color: 'text-core-on-fill-default',
    display: 'flex',
    overflow: 'hidden',
    position: 'relative'
  });
  const cssStyles = useMemo(() => {
    const dimensions = getDimensions(size);
    return Object.assign({}, cssMap, dimensions);
  }, [size, cssMap]);
  if (href) {
    return /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "content-holder-link",
      use: "unstyled",
      href: href,
      children: [/*#__PURE__*/_jsx(ContentHolder, Object.assign({}, contentHolderProps, {
        $cssStyles: cssStyles,
        children: children
      })), socialNetwork ? /*#__PURE__*/_jsx(SocialBadge, {
        socialNetwork: socialNetwork,
        size: size
      }) : null]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ContentHolder, Object.assign({}, contentHolderProps, {
      $cssStyles: cssStyles,
      children: children
    })), socialNetwork ? /*#__PURE__*/_jsx(SocialBadge, {
      socialNetwork: socialNetwork,
      size: size
    }) : null]
  });
};
export default AvatarContentHolder;